"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useI18N = exports.I18NContext = void 0;

var _identity2 = _interopRequireDefault(require("lodash/fp/identity"));

var _join2 = _interopRequireDefault(require("lodash/fp/join"));

var _values2 = _interopRequireDefault(require("lodash/fp/values"));

var _every2 = _interopRequireDefault(require("lodash/fp/every"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _react = require("react");

var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-ignore
var mapWithIndex = _map2.default.convert({
  cap: false
});

var I18NContext = (0, _react.createContext)(_identity2.default);
exports.I18NContext = I18NContext;

var useI18N = function () {
  return (0, _react.useContext)(I18NContext);
};

exports.useI18N = useI18N;

var _default = function _default(messages, config) {
  if (config === void 0) {
    config = {
      ignoreNoMessageWarning: false
    };
  }

  return function (messageKey, values) {
    if (!messages) {
      throw new Error('Messages is required');
    }

    if (!messageKey) {
      throw new Error('messageKey is required');
    }

    var message = (0, _prop2.default)(messageKey)(messages);

    if (!message) {
      if (!config.ignoreNoMessageWarning) {
        console.warn("No message for key: " + messageKey);
      }

      return messageKey;
    }

    try {
      return (0, _flow2.default)(_icuMessageformatParser.parse, mapWithIndex(function (element, index) {
        var type = element.type;

        if ((0, _icuMessageformatParser.isLiteralElement)(element)) {
          return element.value;
        }

        if ((0, _icuMessageformatParser.isArgumentElement)(element)) {
          var argumentValue = (0, _prop2.default)(element.value)(values);
          return (0, _react.isValidElement)(argumentValue) ? (0, _react.cloneElement)(argumentValue, {
            key: "" + element.value + index
          }) : argumentValue;
        }

        throw new Error("Element type is not handled for: " + type);
      }), (0, _flow2.default)(_values2.default, (0, _every2.default)(function (value) {
        return typeof value === 'string' || typeof value === 'number';
      }))(values) ? (0, _join2.default)('') : _identity2.default)(message);
    } catch (e) {
      if (values) {
        throw new Error("Error for messageKey: " + messageKey + " and values: " + JSON.stringify(values));
      }

      throw new Error("Error for messageKey: " + messageKey);
    }
  };
};

exports.default = _default;